"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _react = require("react");

var defaultOptions = {
  current: 1,
  splitter: [1, 1, 1],
  onChange: function onChange() {},
  label: function label(page) {
    return page;
  }
};

function usePagination(options) {
  var _Object$assign = (0, _assign["default"])({}, defaultOptions, options),
      current = _Object$assign.current,
      splitter = _Object$assign.splitter,
      onChange = _Object$assign.onChange,
      count = _Object$assign.count,
      href = _Object$assign.href,
      label = _Object$assign.label;

  var nextPage = Math.min(current + 1, count);
  var prevPage = Math.max(current - 1, 1);

  var goToNext = function goToNext() {
    onChange(nextPage);
  };

  var goToPrev = function goToPrev() {
    onChange(prevPage);
  };

  var goTo = function goTo(index) {
    if (index < 1 || index > count) {
      throw new Error("[usePagination] wrong attribute for goTo, must be between 1 to ".concat(count, " (was ").concat(index, ")"));
    }

    onChange(index);
  };

  var pageArray = (0, _from["default"])(Array(count).keys()).map(function (x) {
    return x + 1;
  }); // button groups

  var pageButtonGroups = [];
  var parts = [];

  if (count <= splitter[0] + splitter[1] * 2 + 1 + splitter[2]) {
    pageButtonGroups.push(pageArray);
  } else {
    if (current <= splitter[0] + splitter[1] + 1) {
      pageButtonGroups.push(pageArray.slice(0, current + splitter[1]));
      pageButtonGroups.push(pageArray.slice(-splitter[2]));
    } else if (current >= count - (splitter[2] + splitter[1])) {
      pageButtonGroups.push(pageArray.slice(0, splitter[0]));
      pageButtonGroups.push(pageArray.slice(current - 1 - splitter[1], count));
    } else {
      pageButtonGroups.push(pageArray.slice(0, splitter[0]));
      pageButtonGroups.push(pageArray.slice(current - 1 - splitter[1], current - 1 + splitter[1] + 1));
      pageButtonGroups.push(pageArray.slice(-splitter[2]));
    }
  }

  pageButtonGroups.forEach(function (group, index) {
    if (index > 0) {
      parts.push({
        type: "separator"
      });
    }

    parts.push({
      type: "buttons",
      buttons: group.map(function (page) {
        return {
          page: page,
          props: {
            onClick: function onClick() {
              return goTo(page);
            },
            href: href ? href(page) : undefined
          }
        };
      })
    });
  });
  var selectOptions = pageArray.map(function (page) {
    return {
      value: page.toString(),
      label: label(page),
      page: page
    };
  });
  var vals = {
    current: current,
    count: count,
    prevButtonActive: current > 1,
    nextButtonActive: current < count,
    nextButtonProps: {
      onClick: goToNext,
      href: href ? href(nextPage) : undefined
    },
    prevButtonProps: {
      onClick: goToPrev,
      href: href ? href(prevPage) : undefined
    },
    goToNext: goToNext,
    goToPrevious: goToPrev,
    goTo: goTo,
    selectProps: {
      options: selectOptions,
      value: selectOptions[current - 1],
      onChange: function onChange(val) {
        goTo(val.page);
      }
    },
    parts: parts
  };
  return vals;
}

var _default = usePagination;
exports["default"] = _default;